import {http} from './index';
import {IReqAddProcess, IReqcheckTimeIsCan, IReqcheckTimes, IReqGetProducts, IReqGetStudentListBy, 
    IReqGetSubjectOfTeam, IReqgetTeamOfStudentsCan} from '../types';
//老师添加预约服务
export const addProcess = (params: IReqAddProcess) => http.post('/teaching-workbench/booking/teacher/addProcess', params);

//学员测评预约次数校验
export const checkTimesOfcePing = (params: IReqcheckTimes) => http.post('/teaching-workbench/booking/teacher/member/booking/online', params);

//校验学员某个时间是否预约过
export const checkTimeIsCan = (params: IReqcheckTimeIsCan) => http.post('/teaching-workbench/booking/teacher/check/member/process/time', params);

//获取学生用户权限下的有效产品，产品周期
export const getProducts = (params: IReqGetProducts) => http.get('/teaching-workbench/booking/teacher/member/have/permission/product', params);

//获取学生用户权限下的服务团队
export const getTeamOfStudentsCan = (params: IReqgetTeamOfStudentsCan) => http.get('/teaching-workbench/booking/teacher/permission/service/team', params);

//获取该产品可以选择的科目、上课方式，学员历史订单的预约手机号
export const getSubjectOfTeam = (params: IReqGetSubjectOfTeam) => http.get('/teaching-workbench/booking/teacher/member/booking/subject', params);

//通过指定条件获取学员列表
export const getStudentListBy = (params: IReqGetStudentListBy) => http.get('/teaching-workbench/booking/teacher/member/list', params);

//老师添加预约-根据学生id获取测评报告
export const getEvaluationOfStudent = (params: {studentId:string|number}) => http.get(`/teaching-workbench/booking/teacher/evaluation/report/${params.studentId}/get-list`);

//根据能力（二级科目）获取老师列表
export const getTeacherBySubject = (params: any) => http.get('/teaching-workbench/booking/teacher/get-list-by-subject', params);


export const getPhoneByStudentId = (studentId: number|string|undefined) => http.get(`/teaching-workbench/booking/teacher/last-reserve-mobile/${studentId}`);
